import React, { Component } from 'react';
import PropTypes from 'prop-types';
import loading from './loading.svg';
import './LoadingV2.css';

class LoadingV2 extends Component {
  static propTypes = {
    hide: PropTypes.bool,
  };

  static defaultProps = {
    hide: false,
  }

  render() {
    const { hide } = this.props;
    const componentClasses = ['animated'];
    if (hide) {
      componentClasses.push('fadeOut');
    }

    return (
      <div className="loadingContainer">
        <div className={componentClasses.join(' ')}>
          <img src={loading} alt="loading" width="35" />
        </div>
      </div>
    );
  }
}

export default LoadingV2;



// WEBPACK FOOTER //
// ./src/components/loading-v2/LoadingV2.js